export default {
    // intercomId: 'cao5rcj3'
}